export const PERSONAL_AREA = {
  LABEL: 'personal.personal_information',
  PERSONAL: '458730d9-39bb-477d-a5cd-ece4d39741e4',
  FOREIGN: '726680d9-7491-4926-9c50-7421303ee337',
  BANK_ACCOUNTS: '192301a5-6577-4ed0-b4ae-f5823e3f1d31',
  EDUCATIONS: '8943ac35-d9f4-4df7-844c-a80456a3da00',
  HANDICAP: '2acc854c-e4db-4828-9807-aa2e27e0df71',
}
